import React from 'react'
import { Form } from 'react-final-form'
import { useMutation } from '@apollo/react-hooks'
import { useFlag } from 'toggled'

import { resetPasswordMutation } from '~/gql/mutations'
import { DefaultLayout, PrivateAuthLayout } from '~/layouts'
import { formValidators, handleSubmissionErrors } from '~/utils'
import { flags } from '~/utils/constants'

import ResetPasswordForm from './ResetPasswordForm'

function ResetPasswordScreen() {
  const [resetPassword] = useMutation(resetPasswordMutation)

  const hasLoginRequiredFF = useFlag(flags.LOGIN_REQUIRED)

  const onSubmit = async values => {
    try {
      await resetPassword({ variables: values })
    } catch (error) {
      return handleSubmissionErrors(error)
    }
  }

  return (
    <Form onSubmit={onSubmit} validate={formValidators.resetPassword}>
      {formProps => {
        if (hasLoginRequiredFF) {
          return (
            <PrivateAuthLayout>
              <div className="flex flex-col gap-4">
                <h4 className="text-center text-xl font-semibold">Recuperar Contraseña</h4>
                <ResetPasswordForm
                  handleSubmit={formProps.handleSubmit}
                  submitting={formProps.submitting}
                  submitSucceeded={formProps.submitSucceeded}
                />
              </div>
            </PrivateAuthLayout>
          )
        }

        return (
          <DefaultLayout>
            <div className="mx-auto flex w-full flex-col gap-4 lg:w-1/2">
              <h4 className="text-center text-xl font-semibold">Recuperar Contraseña</h4>
              <ResetPasswordForm
                handleSubmit={formProps.handleSubmit}
                submitting={formProps.submitting}
                submitSucceeded={formProps.submitSucceeded}
              />
            </div>
          </DefaultLayout>
        )
      }}
    </Form>
  )
}

export default ResetPasswordScreen
